import Vue from "vue";
import store from "@/store";

import {
  jwt,
  isOnboardingCompleted,
  handleTokenExpire,
  getRedirectUrl,
  setRedirectUrl,
  handleNewSession,
  setNewJwt
} from "@/helpers/main";

import {
  changeFirstTransitionStatus,
  executableLastVisitedPageRedirect,
  isOnboardingPage,
  lastVisitedPage
} from "@/helpers/onboarding";

import { changeGeneralLocalStorageVariables } from "@/helpers/common";
import { localStorageKeys } from "@/enums/common";

async function guardRoute(to, from, next) {
  let newSession = false;


  if (jwt()) {
    await handleTokenExpire();
  } else if (to.query.sk) {
    changeGeneralLocalStorageVariables({
      key: localStorageKeys.jwtSessionKey,
      value: to.query.sk
    });

    await setNewJwt();
    newSession = true;
  }

  if (newSession && jwt()) {
    await handleNewSession(next);
  }

  if (jwt() && !isOnboardingCompleted() && to.query["selected-plan"]) {
    changeGeneralLocalStorageVariables({
      key: localStorageKeys.selectedPlan,
      value: to.query["selected-plan"]
    });
  }

  redirect(to, from, next);
}

async function redirect(to, from, next) {
  const executableLastVisitedPage = executableLastVisitedPageRedirect();
  changeFirstTransitionStatus(false);

  if (!jwt()) {
    next({ name: "login", query: { redirect: to.fullPath } });

    return;
  }

  if (!isOnboardingCompleted() && !isOnboardingPage(to.name)) {
    next({ name: "customize" });

    return;
  }

  if (isOnboardingPage(to.name) && executableLastVisitedPage) {
    next({ path: lastVisitedPage() });

    return;
  }

  if (to.query.statusCode == "sessionExpired") {
    showSessionExpiredNotification();
  }

  if (isOnboardingCompleted() && isOnboardingPage(to.name)) {
    next({ name: "dashboard" });

    return;
  }

  if (getRedirectUrl()) {
    next({ path: getRedirectUrl() });

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.redirectURL,
      removeKey: true
    });

    return;
  }

  next();
}

function guardLoginRoute(to, from, next) {
  setRedirectUrl(to.query.redirect);

  if (jwt()) {
    next({ path: getRedirectUrl() || "/" });

    changeGeneralLocalStorageVariables({
      key: localStorageKeys.redirectURL,
      removeKey: true
    });
  } else {
    next();
  }
}

function guardShopifyLoginRoute(to, from, next) {
  if (to.query.data) {
    next();
  } else {
    next({ name: "login" });
  }
}

function setDocumentTitle(to) {
  if (!to?.meta?.title) {
    document.title = "Heybooster";
  } else {
    document.title = typeof to.meta.title === "function" ? to.meta.title(to) : to.meta.title;
  }
}

function getRouterMetaTitle(title, dynamicTitle = "") {
  let documentTitle = "";
  if (dynamicTitle) documentTitle = `${dynamicTitle ? `${dynamicTitle} - ` : ""}`;
  documentTitle += `${title} | ${store.getters["whiteLabel/getWhiteLabelTitle"]}`;
  return documentTitle;
}

function setHeadTitle(router) {
  router.afterEach((to, from) => {
    Vue.nextTick(setDocumentTitle(to));
  });
}

function showSessionExpiredNotification() {
  const notification = {
    code: "urgent",
    title: `Your connection period has expired. Please Sign out, Login and Try again | Now <a href="/logout" class="text-accent">sign out<a/>.`
  };
  store.commit("notifications/setNotification", notification, { root: true });
}

export { guardRoute, guardLoginRoute, setHeadTitle, getRouterMetaTitle, guardShopifyLoginRoute };



// WEBPACK FOOTER //
// ./src/helpers/router/index.js